import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import Box from '@material-ui/core/Box';

import { primary, grey } from '../style';

export const RadioIcon = ({ htmlColor }) => {
  return (
    <SvgIcon htmlColor={htmlColor || grey}>
      <path d="M20.684 5.03c0-2.833-2.3-5.134-5.134-5.134H5.28A5.137 5.137 0 0 0 .147 5.031V15.3c0 2.834 2.301 5.134 5.135 5.134H15.55c2.834 0 5.134-2.3 5.134-5.134z" />
    </SvgIcon>
  );
};

export const RadioFillIcon = ({ htmlColor, fillColor }) => {
  return (
    <SvgIcon htmlColor={htmlColor || grey}>
      <path d="M20.684 5.493c0-2.834-2.3-5.135-5.134-5.135H5.28A5.137 5.137 0 0 0 .147 5.493v10.269c0 2.834 2.301 5.134 5.135 5.134H15.55c2.834 0 5.134-2.3 5.134-5.134z" />
      <path
        fill={fillColor || primary}
        d="M15.72 7.975a2.653 2.653 0 0 0-2.653-2.652H7.764a2.653 2.653 0 0 0-2.652 2.652v5.305a2.653 2.653 0 0 0 2.652 2.652h5.304a2.653 2.653 0 0 0 2.653-2.652z"
      />
    </SvgIcon>
  );
};



// WEBPACK FOOTER //
// ./src/style/radioIcons.js